import HttpClient from "@/common/boot/HttpClient"

const abrirTicket = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  return await HttpClient.post('/pco-workflows/recuperacao/ticket', payload).then(response => {
    return response.data.data;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const abrirTicketInstalacao = async ( { commit }, payload ) => {
  commit('CARREGANDO', true);

  return await HttpClient.post('/pco-workflows/instalacao/ticket', payload).then(response => {
    return response.data.data;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const importarTickets = async (_, formData) => {
  return HttpClient.post('/pco-workflows/recuperacao/tickets/importar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

const verificarStatusImportacaoTicket = async (_, jobId) => {
  return HttpClient.get(`/pco-workflows/recuperacao/tickets/importar/${jobId}/status`);
}

const baixarModeloImportacaoTicket = async () => {
  const response = await HttpClient.get('/pco-workflows/recuperacao/tickets/modelo', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'modelo_importacao_tickets.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

const buscarHistoricoImportacoes = async () => {
  return HttpClient.get('/pco-workflows/recuperacao/tickets/historico-importacoes');
}

export {
  abrirTicket,
  abrirTicketInstalacao,
  importarTickets,
  verificarStatusImportacaoTicket,
  baixarModeloImportacaoTicket,
  buscarHistoricoImportacoes,
}